import { SnackbarKey } from 'notistack'

import { CloseAction } from './CloseAction'

export const mergeCloseAction = (
  action: React.JSX.Element,
  snackbarId: SnackbarKey,
): React.JSX.Element => (
  <>
    {action}
    <CloseAction snackbarId={snackbarId} />
  </>
)
